import { Store } from 'pullstate';
import { PagedList, UserOverview } from '../types/common';

const UserStore = new Store({
    users: [] as UserOverview[]    
});

export default UserStore;